import React from 'react';
import Icon from 'src/components/common/Icon';

import css from './CreateHub.module.scss';
import { useTypewriter } from './helpers';

function BotAvatar() {
  return (
    <span className={css.botAvatar} aria-hidden>
      <Icon type="header-logo" />
    </span>
  );
}

export function BotThinkingIndicator() {
  return (
    <div className={css.botRow} aria-label="כותב" role="status">
      <BotAvatar />
      <div className={css.thinkingDots}>
        <span className={css.thinkingDot} />
        <span className={css.thinkingDot} />
        <span className={css.thinkingDot} />
      </div>
    </div>
  );
}

type BotMessageProps = {
  text: string;
  animate?: boolean;
  onTypingComplete?: () => void;
  onTypingTick?: () => void;
};

export function BotMessage({ text, animate = false, onTypingComplete, onTypingTick }: BotMessageProps) {
  const { displayed, isDone } = useTypewriter(text, animate);
  const completedRef = React.useRef(false);

  React.useEffect(() => {
    if (!animate || !isDone || completedRef.current) return;
    completedRef.current = true;
    onTypingComplete?.();
  }, [animate, isDone, onTypingComplete]);

  React.useEffect(() => {
    if (animate && !isDone) {
      onTypingTick?.();
    }
  }, [animate, displayed, isDone, onTypingTick]);

  return (
    <div className={css.botRow}>
      <BotAvatar />
      <p className={css.botText} aria-live={animate && !isDone ? 'polite' : 'off'}>
        {displayed}
        {animate && !isDone && <span className={css.typeCursor} aria-hidden />}
      </p>
    </div>
  );
}
